const PIE_COLORS = {
    light:  ['turquoise', 'azure', 'pastel-blue'],
    dark:   ['salmon', 'grass', 'purple']
}

const STATS_PIE_COLORS = {
    light:  ['turquoise', 'azure', 'pastel-blue'],
    dark:   ['salmon', 'grass', 'purple']
}

const PASSES_PIE_COLORS = {
    "shots": "salmon",
    "passes": "grass",
    "crosses": "pastel-blue",
    "saves": "salmon",
    "corners": "grass",
    "outs": "purple"
}

export {PIE_COLORS, PASSES_PIE_COLORS, STATS_PIE_COLORS}